import Counter from '../Fields/Counter'

const TextSwitcher = (props) => {
  return <Counter {...props} />
}

export default TextSwitcher
